import i18n from '@/utils/i18n';
import { Badge, BadgeSize } from '@usepepper/ui/atoms/badge';
import { type FC, useMemo } from 'react';
import { SmartOrderStatus } from '@/enums';
import { useTheme } from '@/contexts/theme-context';
import type { OrderMetadata } from '@/screens/order-inbounds/types';

interface Props {
  order: OrderMetadata;
}

export const OrderInboundsDetailEmlHeaderStatusBadge: FC<Props> = ({
  order,
}) => {
  const theme = useTheme();

  const { badgeStyle, label } = useMemo(() => {
    let backgroundColor: string;
    let borderColor: string | undefined;
    let label: string;

    switch (order.status) {
      case SmartOrderStatus.SUBMITTED:
        backgroundColor = theme.sk.color.bg.success;
        borderColor = theme.colors.transparent;
        label = i18n.t('order_inbound.submitted');
        break;
      case SmartOrderStatus.REJECTED:
        backgroundColor = theme.sk.color.bg.error;
        borderColor = theme.colors.transparent;
        label = i18n.t('order_inbound.status_badge.rejected');
        break;
      default:
        backgroundColor = theme.sk.color.bg.secondary.default;
        borderColor = theme.sk.color.border.primary;
        label = i18n.t('order_inbound.status_badge.new');
        break;
    }

    return {
      badgeStyle: {
        backgroundColor,
        borderColor,
        borderRadius: theme.sk.radii.radiusSmall,
        borderWidth: 1,
      },
      label,
    };
  }, [theme, order]);

  return <Badge label={label} size={BadgeSize.SMALL} style={badgeStyle} />;
};
